module.exports = __webpack_public_path__ + "assets/inside_of_service_area.be6cbfe0.svg";